import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { createClient } from '@/prismicio';
import CaseStudiesCarouselClient from './CaseStudiesCarouselClient';
import FromMarkedCases from './variations/FromMarkedCases';
import CaseStudiesFeedTwoColumns from './variations/CaseStudiesFeedTwoColumns';
import { resolveCaseStudiesFromPicks } from './server/resolveCaseStudies';

export type CaseStudiesCarouselProps =
  SliceComponentProps<Content.TestimonialCarousel2Slice>;

/**
 * Slice dispatcher.
 *
 * The legacy variations (default / withFilters / withoutFilters /
 * caseStudiesCarouselWithoutBgp / casestudieswithlogoandreview) are rendered
 * by the original client component (`./CaseStudiesCarouselClient`), untouched.
 *
 * The data-driven variations (`fromMarkedCases`, `caseStudiesFeedTwoColumns`)
 * share the same server resolver in `./server/resolveCaseStudies`: editor
 * picks first, fallback to every `case_study` doc (minus SUPERSEDED legacy
 * UIDs so a client never appears twice while a rework is being rolled out).
 * They diverge only in presentation.
 */
const CaseStudiesCarousel = async (props: CaseStudiesCarouselProps) => {
  if (props.slice.variation === 'fromMarkedCases') {
    const caseStudies = await resolveCaseStudiesFromPicks(
      createClient(),
      props.slice.primary.featured_case_studies,
      'CaseStudiesCarousel.fromMarkedCases',
    );
    return <FromMarkedCases slice={props.slice} caseStudies={caseStudies} />;
  }

  if (props.slice.variation === 'caseStudiesFeedTwoColumns') {
    const caseStudies = await resolveCaseStudiesFromPicks(
      createClient(),
      props.slice.primary.featured_case_studies,
      'CaseStudiesCarousel.caseStudiesFeedTwoColumns',
    );
    return (
      <CaseStudiesFeedTwoColumns
        slice={props.slice}
        caseStudies={caseStudies}
      />
    );
  }

  return <CaseStudiesCarouselClient {...props} />;
};

export default CaseStudiesCarousel;
